"use strict";
const axios = require('axios');
const axiosRetry = require('axios-retry');
const { get } = require('lodash');
const qs = require('qs');
const { getTraceId } = require('./tracerService');
const DEFAULT_NUMBER_OF_RETRIES = 3;
const retryDelay = (retryCount) => (3 * 1000) * retryCount;
const retryCondition = (axiosError) => {
    const status = get(axiosError, 'response.status');
    return status > 500;
};
const DEFAULT_RETRY_CONFIG = {
    retries: DEFAULT_NUMBER_OF_RETRIES,
    retryDelay,
    retryCondition,
    shouldResetTimeout: true,
};
const addInterceptors = (axiosInstance) => {
    axiosInstance.interceptors.request.use((config) => ({
        ...config,
        headers: {
            ...config.headers,
            trace_id: getTraceId(),
        },
    }), (error) => Promise.reject(error));
    axiosInstance.interceptors.response.use((response) => response, (error) => {
        const backwardCompatibleError = {
            ...error,
            code: error.response?.status || 500,
            message: error.response?.data || error.message,
        };
        return Promise.reject(backwardCompatibleError);
    });
};
const instance = () => {
    const axiosInstance = axios.create();
    addInterceptors(axiosInstance);
    return axiosInstance;
};
const httpService = instance();
const setUpRetry = (userConfig = {}) => {
    const config = { ...DEFAULT_RETRY_CONFIG, ...userConfig };
    axiosRetry(httpService, config);
};
module.exports = httpService;
httpService.setUpRetry = setUpRetry;
httpService.qs = qs;
//# sourceMappingURL=httpService.js.map